"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setMailchimpSyncStatusEpic = exports.loadMailchimpSyncStatus = exports.updateEspSync = exports.removeLastEspSyncError = exports.loadEspSync = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var loadEspSync = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.EspSyncActionType.LOAD_ESP_SYNC,
  requestStatusSelector: _selectors.getFetchEspSyncRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.FetchEspSync
}));
exports.loadEspSync = loadEspSync;
var removeLastEspSyncError = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.removeLastError,
  initiatingActionType: _actions.EspSyncActionType.REMOVE_LAST_ESP_SYNC_ERROR,
  requestStatusSelector: _selectors.getRemoveLastEspSyncErrorRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.RemoveLastEspSyncError
}));
exports.removeLastEspSyncError = removeLastEspSyncError;
var updateEspSync = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.EspSyncActionType.UPDATE_ESP_SYNC,
  requestStatusSelector: _selectors.getUpdateEspSyncRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateEspSync
}));
exports.updateEspSync = updateEspSync;
var loadMailchimpSyncStatus = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getMailchimpSyncStatus,
  initiatingActionType: _actions.EspSyncActionType.LOAD_MAILCHIMP_SYNC_STATUS,
  requestStatusSelector: _selectors.getFetchMailchimpSyncStatusRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.FetchMailchimpSyncStatus
}));
exports.loadMailchimpSyncStatus = loadMailchimpSyncStatus;
var setMailchimpSyncStatusEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setMailchimpSyncStatus,
  initiatingActionType: _actions.EspSyncActionType.SET_MAILCHIMP_SYNC_STATUS,
  requestStatusSelector: _selectors.getSetMailchimpSyncStatusRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.updateMailchimpSyncStatus
}));
exports.setMailchimpSyncStatusEpic = setMailchimpSyncStatusEpic;

var _default = (0, _reduxObservable.combineEpics)(loadEspSync, loadMailchimpSyncStatus, removeLastEspSyncError, updateEspSync, setMailchimpSyncStatusEpic);

exports.default = _default;